import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';

// For production: Load config from window.awsExports (set by aws-exports.js)
// For development: Fall back to local aws-exports.js
let awsConfig;
if (window.awsExports) {
  awsConfig = window.awsExports;
} else {
  // Local development fallback
  const awsExports = require('./aws-exports').default;
  awsConfig = awsExports;
}

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
